import { AfterViewInit, Component, forwardRef, Injector, OnDestroy, ViewChild } from '@angular/core';
import { IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import E from 'wangeditor';

@Component({
  selector: 'app-r-ueditor',
  templateUrl: './r-ueditor.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RUeditorComponent),
      multi: true
    }
  ]
})
export class RUeditorComponent extends RenderComponentBase {
  static KEY = 'r-d-ueditor';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {}
}
